// The Admin pages: Users, Interview prompts and the Cost ledger, one address
// each (dashboard/adminPages.js). Laid out as the other EquaOS apps are
// (owner, 29 Oct 2026: "make it look exactly like the other systems"): each
// page draws its own PageHeader, figures and sections from the page kit; this
// file only picks the page and holds the users list they share.
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Button, Card, Icon } from "../ds";
import { Page, Loading, Note } from "../components/page";
import UsersTable from "./UsersTable";
import UserActivityDashboard from "./UserActivityDashboard";
import api from "../services/api";
import AdminPromptsPanel from "./admin/AdminPromptsPanel";
import AdminLlmCostPanel from "./admin/AdminLlmCostPanel";
import { adminPageFor } from "./adminPages";
import { PLATFORM_TIER } from "../config/base";

const AdminDashboard = () => {
  // Which admin page: the address's (dashboard/adminPages.js). They are
  // sidebar entries now, not tabs across the top.
  const activeTab = adminPageFor(useLocation().pathname).key;
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userRole, setUserRole] = useState(null);
  useEffect(()=>{
    console.log("userRole",userRole)
  },[userRole])
  useEffect(() => {
    const user = localStorage.getItem("user");
    const userObj = JSON.parse(user);
    const userRole = userObj.role;
    if (userRole === "user" && users.length > 0) {
      const user = users.find((user) => user._id === userObj.id);
      console.log(user, "user");
      setUserRole(userRole);
      setSelectedUser(user);
    }
    else if(userRole==="admin") {
      setUserRole("admin")
    }
  }, [users, selectedUser]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // The old overview's figures moved to the Dashboard (owner, 29 Oct 2026);
  // the stats call stays because the page waits on it before showing.
  const [, setDashboardStats] = useState(null);
  useEffect(() => {
    fetchDashboardData();
    fetchUsers();
  }, []);
  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const response = await api.get("/admin/dashboard/stats");
      if (response.data) {
        setDashboardStats(response.data);
      }
    } catch (err) {
      console.error("Error fetching dashboard data:", err);
      setError("Failed to load dashboard statistics");
    } finally {
      setLoading(false);
    }
  };
  const fetchUsers = async () => {
    try {
      const response = await api.get("/admin/users");
      setUsers(response.data.users || []);
    } catch (err) {
      console.error("Error fetching users:", err);
      setError("Error fetching users");
    }
  };
  const handleViewActivity = (user) => {
    if (!user?._id) {
      console.error("Invalid user data:", user);
      return;
    }
    setSelectedUser(user);
  };
  const handleBack = () => {
    setSelectedUser(null);
  };
  const handleUserDelete = async (userId) => {
    try {
      await api.delete(`/admin/users/${userId}`);
      fetchUsers();
    } catch (err) {
      console.error("Error deleting user:", err);
    }
  }
  if (loading) {
    return <Card><Loading /></Card>;
  }

  // One user's activity: its own page, with the way back for an admin.
  if (selectedUser) {
    return (
      <UserActivityDashboard
        userId={selectedUser._id}
        userName={selectedUser.name}
        key={selectedUser._id}
        notice={error && <Note tone="danger">{error}</Note>}
        backAction={userRole === "admin" && (
          <Button variant="secondary" icon={<Icon name="arrow-left" />} onClick={handleBack}>
            Back to Users
          </Button>
        )}
      />
    );
  }

  return (
    <Page>
      {error && <Note tone="danger">{error}</Note>}
      {/* Three pages (owner, 29 Oct 2026). The Cost ledger is what the AI
          providers charged; the wallet ledger went with Token management. */}
      {/* EquaOS's base prompts: the platform tier only (30 Oct 2026). A
          school sets up each interview with its brief instead. */}
      {activeTab === "prompts" && (PLATFORM_TIER ? <AdminPromptsPanel /> : (
        <Note tone="info">
          The AI interviewer's instructions are managed by EquaOS. To set up an interview, open the role's AI interview stage and edit its interview brief: the goal, the questions and what a good answer looks like.
        </Note>
      ))}
      {activeTab === "ledger"  && <AdminLlmCostPanel />}
      {activeTab === "users" && Array.isArray(users) && (
        <UsersTable
          users={users}
          onEdit={() => {}}
          onDelete={handleUserDelete}
          onViewActivity={handleViewActivity}
          onRefresh={fetchUsers}
        />
      )}
    </Page>
  );
};
export default AdminDashboard;
